module.exports = __webpack_public_path__ + "img/tarjeta_beneficios_clubMMT.9784c76c.jpg";